import _ from 'lodash';
import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { MosaicCard } from './mosaic-card';
import { MosaicDivider } from './mosaic-divider';

const animate = 'animate__animated animate__fadeInLeft animate__delay-1s';

function Mosaic({ categories, onSelect }) {
  const classes = useStyles();
  const totalCols = 2;

  const rows = useMemo(() => {
    const result = [];
    let row = [];

    categories?.forEach((category, index) => {
      row.push(category);

      if ((index + 1) % totalCols === 0) {
        result.push(row);
        row = [];
      }
    });

    if (!_.isEmpty(row)) {
      if (row.length % totalCols !== 0) {
        row.push(null);
      }

      result.push(row);
    }

    return result;
  }, [categories]);

  return (
    !_.isEmpty(rows) && (
      <>
        <MosaicDivider
          className={animate}
          style={{ '--animate-delay': '1.3s' }}
        />
        <div className={classes.container}>
          {rows.map((row, rowIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={rowIndex} className={classes.row}>
              {row?.map((category, colIndex) => (
                <MosaicCard
                  key={category?.id ?? 0}
                  className={classes.co}
                  category={category}
                  siblings={
                    row?.filter((r) => r?.id !== category?.id)
                    // ?.map((r) => r?.category)
                  }
                  row={rowIndex}
                  col={colIndex}
                  length={categories?.length}
                  totalRows={rows.length}
                  totalCols={totalCols}
                  onSelect={onSelect}
                />
              ))}
            </div>
          ))}
        </div>
        <MosaicDivider
          className={animate}
          style={{ '--animate-delay': '1.3s' }}
        />
      </>
    )
  );
}

const useStyles = createUseStyles({
  container: {
    // display: "flex",
    // flexDirection: "row",
    // border: "1px solid white",
    paddingTop: layoutDefaults.bigVerticalMargin,
    paddingBottom: layoutDefaults.bigVerticalMargin,
    paddingLeft: layoutDefaults.smallHorizontalMargin,
    paddingRight: layoutDefaults.smallHorizontalMargin,
    // padding: layoutDefaults.verticalMargin
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    // justifyContent: "center",
    alignItems: 'unset',
  },
  col: {
    display: 'flex',
    flex: 1,
    // justifyContent: "center",
    // alignItems: "stretch",
    // flexDirection: "column",
    // flexGrow: 1,
    // WebkitFlexGrow: 1,
    // justifyContent: "stretch",
    // alignItems: "stretch",

    // alignSelf: "stretch",
    // self
    // padding: 0,
  },
});

export { Mosaic };
